import { Dispatch } from "redux";
import { setMessageTemplateDetails, setMessageTemplateDetailsLoading } from "@redux/actions/message-template-details-actions";
import { FormattedMessageTemplate } from "@idw-types/data/message-template";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";
import { AxnCompany } from "@idw-types/data/reference-data/axn";
import { getMessageTemplateRequest } from "@requests/axnadmin-core/get-message-template";
import { formatMessageTemplate } from "@formatters/message-templates/message-template-formatter";

export const getMessageTemplateDetailsReduxRequest = (dispatch: Dispatch) => async (
    messageTemplateId: string,
    axnCompanies: Array<AxnCompany>,
): Promise<FormattedMessageTemplate> => {
    dispatch(setMessageTemplateDetailsLoading(true));
    const { data, error } = await getMessageTemplateRequest(messageTemplateId);

    if (data) {
        const formattedMessageTemplate = formatMessageTemplate(data, axnCompanies);
        dispatch(setMessageTemplateDetails(formattedMessageTemplate));
        return formattedMessageTemplate;
    } else {
        if (error) {
            logAndDisplayErrorModal(
                dispatch,
                error,
                resources.requests.getMessageTemplateDetails.error.title,
                resources.requests.getMessageTemplateDetails.error.message
            );
        }
        dispatch(setMessageTemplateDetailsLoading(false));
        return null;
    }
};